import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';
import AppRouter from './routes/AppRouter';
import MouseTrail from './components/MouseTrail';

function App() {
  return (
    <HelmetProvider>
    <Router>
      <div className="app-container">
        <MouseTrail />
        <Navbar />
        <main className="main-content">
          <AppRouter />
        </main>
        <Footer />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
